export const getRolesSelectOptions = (t) => [
  { label: t("auth.roles.ROLE_USER"), value: "ROLE_USER" },
  { label: t("auth.roles.ROLE_MOD"), value: "ROLE_MOD" },
  { label: t("auth.roles.ROLE_ADMIN"), value: "ROLE_ADMIN" },
  { label: t("auth.roles.ROLE_KADR"), value: "ROLE_KADR" },
];
